/* tslint:disable */
/* eslint-disable */
/**
 * settingManage API
 * 設定管理APIの定義
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 自由欄設定
 * @export
 * @interface ApiBusinessFreeColumnSetting
 */
export interface ApiBusinessFreeColumnSetting {
    /**
     * 集計取引の自由欄設定
     * @type {Array<ApiBusinessFreeColumnSettingItem>}
     * @memberof ApiBusinessFreeColumnSetting
     */
    'aggregate': Array<ApiBusinessFreeColumnSettingItem>;
    /**
     * 関連取引の自由欄設定
     * @type {Array<ApiBusinessFreeColumnSettingItem>}
     * @memberof ApiBusinessFreeColumnSetting
     */
    'base': Array<ApiBusinessFreeColumnSettingItem>;
}
/**
 * 自由欄1項目の設定
 * @export
 * @interface ApiBusinessFreeColumnSettingItem
 */
export interface ApiBusinessFreeColumnSettingItem {
    /**
     * ヘッダー名
     * @type {string}
     * @memberof ApiBusinessFreeColumnSettingItem
     */
    'headerName': string;
    /**
     * 複数選択を有効にするか
     * @type {boolean}
     * @memberof ApiBusinessFreeColumnSettingItem
     */
    'isMulti': boolean;
    /**
     * ユーザーが設定ページで保存済みかどうか。未保存(=自動デフォルト)なら false。
     * @type {boolean}
     * @memberof ApiBusinessFreeColumnSettingItem
     */
    'isConfigured'?: boolean;
    /**
     * 必須かどうか。自由欄は任意固定。
     * @type {boolean}
     * @memberof ApiBusinessFreeColumnSettingItem
     */
    'required'?: boolean;
    /**
     * データ型。自由欄は文字列固定。
     * @type {string}
     * @memberof ApiBusinessFreeColumnSettingItem
     */
    'dataType'?: string;
}
/**
 * ダッシュボードアラート設定
 * @export
 * @interface ApiDashboardAlertSetting
 */
export interface ApiDashboardAlertSetting {
    /**
     * 
     * @type {ApiDashboardAlertSettingCritical}
     * @memberof ApiDashboardAlertSetting
     */
    'critical': ApiDashboardAlertSettingCritical;
    /**
     * 
     * @type {ApiDashboardAlertSettingWarning}
     * @memberof ApiDashboardAlertSetting
     */
    'warning': ApiDashboardAlertSettingWarning;
}
/**
 * 
 * @export
 * @interface ApiDashboardAlertSettingCritical
 */
export interface ApiDashboardAlertSettingCritical {
    /**
     * 
     * @type {ApiDashboardAlertSettingThresholds}
     * @memberof ApiDashboardAlertSettingCritical
     */
    'excess': ApiDashboardAlertSettingThresholds;
    /**
     * 
     * @type {ApiDashboardAlertSettingCriticalShortageThresholds}
     * @memberof ApiDashboardAlertSettingCritical
     */
    'shortage': ApiDashboardAlertSettingCriticalShortageThresholds;
}
/**
 * 
 * @export
 * @interface ApiDashboardAlertSettingCriticalShortageThresholds
 */
export interface ApiDashboardAlertSettingCriticalShortageThresholds {
    /**
     * 判定対象とする連続月数
     * @type {string}
     * @memberof ApiDashboardAlertSettingCriticalShortageThresholds
     */
    'consecutiveMonths': string;
    /**
     * 内示正答率の閾値
     * @type {string}
     * @memberof ApiDashboardAlertSettingCriticalShortageThresholds
     */
    'ratioThreshold': string;
    /**
     * 前月比の閾値
     * @type {string}
     * @memberof ApiDashboardAlertSettingCriticalShortageThresholds
     */
    'momChangeRateThreshold': string;
    /**
     * 最小検知数量の閾値
     * @type {string}
     * @memberof ApiDashboardAlertSettingCriticalShortageThresholds
     */
    'minQuantityThreshold': string;
    /**
     * 当月内示正答率の閾値
     * @type {string}
     * @memberof ApiDashboardAlertSettingCriticalShortageThresholds
     */
    'currentMonthForecastAccuracyThreshold': string;
}
/**
 * アラート判定に使用する設定値
 * @export
 * @interface ApiDashboardAlertSettingThresholds
 */
export interface ApiDashboardAlertSettingThresholds {
    /**
     * 判定対象とする連続月数
     * @type {string}
     * @memberof ApiDashboardAlertSettingThresholds
     */
    'consecutiveMonths': string;
    /**
     * 内示正答率の閾値
     * @type {string}
     * @memberof ApiDashboardAlertSettingThresholds
     */
    'ratioThreshold': string;
    /**
     * 前月比の閾値
     * @type {string}
     * @memberof ApiDashboardAlertSettingThresholds
     */
    'momChangeRateThreshold': string;
    /**
     * 最小検知数量の閾値
     * @type {string}
     * @memberof ApiDashboardAlertSettingThresholds
     */
    'minQuantityThreshold': string;
}
/**
 * 
 * @export
 * @interface ApiDashboardAlertSettingWarning
 */
export interface ApiDashboardAlertSettingWarning {
    /**
     * 
     * @type {ApiDashboardAlertSettingThresholds}
     * @memberof ApiDashboardAlertSettingWarning
     */
    'excess': ApiDashboardAlertSettingThresholds;
    /**
     * 
     * @type {ApiDashboardAlertSettingThresholds}
     * @memberof ApiDashboardAlertSettingWarning
     */
    'shortage': ApiDashboardAlertSettingThresholds;
}
/**
 * シミュレーション設定
 * @export
 * @interface ApiSimulationSetting
 */
export interface ApiSimulationSetting {
    /**
     * 切り捨てを使用するか
     * @type {boolean}
     * @memberof ApiSimulationSetting
     */
    'useRoundDown': boolean;
    /**
     * 当月販売実績をシミュレーションに含めるか
     * @type {boolean}
     * @memberof ApiSimulationSetting
     */
    'useCurrentMonthSalesResult': boolean;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * 
 * @export
 * @interface GetBusinessFreeColumnSettingSuccessResponseResult
 */
export interface GetBusinessFreeColumnSettingSuccessResponseResult {
    /**
     * 
     * @type {number}
     * @memberof GetBusinessFreeColumnSettingSuccessResponseResult
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetBusinessFreeColumnSettingSuccessResponseResult
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetBusinessFreeColumnSettingSuccessResponseResult
     */
    'message': string;
    /**
     * 
     * @type {ApiBusinessFreeColumnSetting}
     * @memberof GetBusinessFreeColumnSettingSuccessResponseResult
     */
    'result': ApiBusinessFreeColumnSetting;
}
/**
 * 
 * @export
 * @interface GetDashboardAlertSettingSuccessResponseResult
 */
export interface GetDashboardAlertSettingSuccessResponseResult {
    /**
     * 
     * @type {number}
     * @memberof GetDashboardAlertSettingSuccessResponseResult
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetDashboardAlertSettingSuccessResponseResult
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetDashboardAlertSettingSuccessResponseResult
     */
    'message': string;
    /**
     * 
     * @type {ApiDashboardAlertSetting}
     * @memberof GetDashboardAlertSettingSuccessResponseResult
     */
    'result': ApiDashboardAlertSetting;
}
/**
 * 
 * @export
 * @interface GetSimulationSettingSuccessResponseResult
 */
export interface GetSimulationSettingSuccessResponseResult {
    /**
     * 
     * @type {number}
     * @memberof GetSimulationSettingSuccessResponseResult
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetSimulationSettingSuccessResponseResult
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetSimulationSettingSuccessResponseResult
     */
    'message': string;
    /**
     * 
     * @type {ApiSimulationSetting}
     * @memberof GetSimulationSettingSuccessResponseResult
     */
    'result': ApiSimulationSetting;
}
/**
 * 未管理取引の自動登録設定取得レスポンス
 * @export
 * @interface GetUnmanagedBusinessAutoRegisterSettingResponse
 */
export interface GetUnmanagedBusinessAutoRegisterSettingResponse {
    /**
     * 
     * @type {number}
     * @memberof GetUnmanagedBusinessAutoRegisterSettingResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetUnmanagedBusinessAutoRegisterSettingResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetUnmanagedBusinessAutoRegisterSettingResponse
     */
    'message': string;
    /**
     * 
     * @type {UnmanagedBusinessAutoRegisterSettingResult}
     * @memberof GetUnmanagedBusinessAutoRegisterSettingResponse
     */
    'result': UnmanagedBusinessAutoRegisterSettingResult;
}
/**
 * 未管理取引の自動登録設定保存リクエスト
 * @export
 * @interface PutUnmanagedBusinessAutoRegisterSettingRequest
 */
export interface PutUnmanagedBusinessAutoRegisterSettingRequest {
    /**
     * 
     * @type {UnmanagedBusinessAutoRegisterCondition}
     * @memberof PutUnmanagedBusinessAutoRegisterSettingRequest
     */
    'condition': UnmanagedBusinessAutoRegisterCondition;
    /**
     * 取得時に受け取った更新時刻。更新競合判定に使用する
     * @type {number}
     * @memberof PutUnmanagedBusinessAutoRegisterSettingRequest
     */
    'updateAt'?: number | null;
}
/**
 * 未管理取引の自動登録設定保存レスポンス
 * @export
 * @interface PutUnmanagedBusinessAutoRegisterSettingResponse
 */
export interface PutUnmanagedBusinessAutoRegisterSettingResponse {
    /**
     * 
     * @type {number}
     * @memberof PutUnmanagedBusinessAutoRegisterSettingResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PutUnmanagedBusinessAutoRegisterSettingResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PutUnmanagedBusinessAutoRegisterSettingResponse
     */
    'message': string;
    /**
     * 
     * @type {UnmanagedBusinessAutoRegisterSettingResult}
     * @memberof PutUnmanagedBusinessAutoRegisterSettingResponse
     */
    'result': UnmanagedBusinessAutoRegisterSettingResult;
}
/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}
/**
 * 未管理取引の自動登録条件
 * @export
 * @interface UnmanagedBusinessAutoRegisterCondition
 */
export interface UnmanagedBusinessAutoRegisterCondition {
    /**
     * 自動登録機能の有効フラグ
     * @type {boolean}
     * @memberof UnmanagedBusinessAutoRegisterCondition
     */
    'enabled': boolean;
    /**
     * 自動登録設定一覧
     * @type {Array<UnmanagedBusinessAutoRegisterSettingItem>}
     * @memberof UnmanagedBusinessAutoRegisterCondition
     */
    'settings': Array<UnmanagedBusinessAutoRegisterSettingItem>;
}
/**
 * 条件一致時に設定する任意項目
 * @export
 * @interface UnmanagedBusinessAutoRegisterOptionalRegisterItem
 */
export interface UnmanagedBusinessAutoRegisterOptionalRegisterItem {
    /**
     * 
     * @type {UnmanagedBusinessAutoRegisterTargetField}
     * @memberof UnmanagedBusinessAutoRegisterOptionalRegisterItem
     */
    'targetField': UnmanagedBusinessAutoRegisterTargetField;
    /**
     * 登録する値
     * @type {string}
     * @memberof UnmanagedBusinessAutoRegisterOptionalRegisterItem
     */
    'targetValue': string;
}


/**
 * 条件一致時の登録項目
 * @export
 * @interface UnmanagedBusinessAutoRegisterRegisterContent
 */
export interface UnmanagedBusinessAutoRegisterRegisterContent {
    /**
     * リードタイム
     * @type {number}
     * @memberof UnmanagedBusinessAutoRegisterRegisterContent
     */
    'leadTime': number;
    /**
     * 
     * @type {UnmanagedBusinessAutoRegisterRegisterUnit}
     * @memberof UnmanagedBusinessAutoRegisterRegisterContent
     */
    'leadTimeUnit': UnmanagedBusinessAutoRegisterRegisterUnit;
    /**
     * 標準在庫指数min
     * @type {number}
     * @memberof UnmanagedBusinessAutoRegisterRegisterContent
     */
    'stdInventoryIndicesMin': number;
    /**
     * 標準在庫指数max
     * @type {number}
     * @memberof UnmanagedBusinessAutoRegisterRegisterContent
     */
    'stdInventoryIndicesMax': number;
    /**
     * 
     * @type {UnmanagedBusinessAutoRegisterRegisterUnit}
     * @memberof UnmanagedBusinessAutoRegisterRegisterContent
     */
    'stdInventoryIndicesUnit': UnmanagedBusinessAutoRegisterRegisterUnit;
    /**
     * 任意登録項目
     * @type {Array<UnmanagedBusinessAutoRegisterOptionalRegisterItem>}
     * @memberof UnmanagedBusinessAutoRegisterRegisterContent
     */
    'optionalItems': Array<UnmanagedBusinessAutoRegisterOptionalRegisterItem>;
}


/**
 * 条件一致時の登録単位
 * @export
 * @enum {string}
 */

export const UnmanagedBusinessAutoRegisterRegisterUnit = {
    Day: 'day',
    Week: 'week',
    Month: 'month'
} as const;

export type UnmanagedBusinessAutoRegisterRegisterUnit = typeof UnmanagedBusinessAutoRegisterRegisterUnit[keyof typeof UnmanagedBusinessAutoRegisterRegisterUnit];


/**
 * 未管理取引の自動登録設定
 * @export
 * @interface UnmanagedBusinessAutoRegisterSetting
 */
export interface UnmanagedBusinessAutoRegisterSetting {
    /**
     * 
     * @type {UnmanagedBusinessAutoRegisterCondition}
     * @memberof UnmanagedBusinessAutoRegisterSetting
     */
    'condition': UnmanagedBusinessAutoRegisterCondition;
    /**
     * 設定の最終更新時刻
     * @type {number}
     * @memberof UnmanagedBusinessAutoRegisterSetting
     */
    'updateAt'?: number | null;
}
/**
 * 設定1件内の判定条件
 * @export
 * @interface UnmanagedBusinessAutoRegisterSettingCondition
 */
export interface UnmanagedBusinessAutoRegisterSettingCondition {
    /**
     * 
     * @type {UnmanagedBusinessAutoRegisterSettingTargetFieldType}
     * @memberof UnmanagedBusinessAutoRegisterSettingCondition
     */
    'targetFieldType': UnmanagedBusinessAutoRegisterSettingTargetFieldType;
    /**
     * 
     * @type {UnmanagedBusinessAutoRegisterSettingSearchType}
     * @memberof UnmanagedBusinessAutoRegisterSettingCondition
     */
    'searchType': UnmanagedBusinessAutoRegisterSettingSearchType;
    /**
     * 一致させる値
     * @type {string}
     * @memberof UnmanagedBusinessAutoRegisterSettingCondition
     */
    'targetValue': string;
    /**
     * コード一致時に登録する名称
     * @type {string}
     * @memberof UnmanagedBusinessAutoRegisterSettingCondition
     */
    'targetName'?: string;
}


/**
 * 自動登録設定1件
 * @export
 * @interface UnmanagedBusinessAutoRegisterSettingItem
 */
export interface UnmanagedBusinessAutoRegisterSettingItem {
    /**
     * 設定ID
     * @type {string}
     * @memberof UnmanagedBusinessAutoRegisterSettingItem
     */
    'settingId': string;
    /**
     * 設定名
     * @type {string}
     * @memberof UnmanagedBusinessAutoRegisterSettingItem
     */
    'settingName': string;
    /**
     * 設定作成時刻
     * @type {number}
     * @memberof UnmanagedBusinessAutoRegisterSettingItem
     */
    'createdAt': number;
    /**
     * 設定内のAND条件
     * @type {Array<UnmanagedBusinessAutoRegisterSettingCondition>}
     * @memberof UnmanagedBusinessAutoRegisterSettingItem
     */
    'conditions': Array<UnmanagedBusinessAutoRegisterSettingCondition>;
    /**
     * 
     * @type {UnmanagedBusinessAutoRegisterRegisterContent}
     * @memberof UnmanagedBusinessAutoRegisterSettingItem
     */
    'registerContent': UnmanagedBusinessAutoRegisterRegisterContent;
}
/**
 * 未管理取引の自動登録設定レスポンス
 * @export
 * @interface UnmanagedBusinessAutoRegisterSettingResult
 */
export interface UnmanagedBusinessAutoRegisterSettingResult {
    /**
     * 
     * @type {UnmanagedBusinessAutoRegisterSetting}
     * @memberof UnmanagedBusinessAutoRegisterSettingResult
     */
    'setting': UnmanagedBusinessAutoRegisterSetting;
}
/**
 * 自動登録設定で指定する検索方法
 * @export
 * @enum {string}
 */

export const UnmanagedBusinessAutoRegisterSettingSearchType = {
    Code: 'code',
    Name: 'name',
    Value: 'value'
} as const;

export type UnmanagedBusinessAutoRegisterSettingSearchType = typeof UnmanagedBusinessAutoRegisterSettingSearchType[keyof typeof UnmanagedBusinessAutoRegisterSettingSearchType];


/**
 * 自動登録設定で指定する条件項目
 * @export
 * @enum {string}
 */

export const UnmanagedBusinessAutoRegisterSettingTargetFieldType = {
    Supplier: 'supplier',
    Business: 'business',
    Warehouse: 'warehouse',
    Package: 'package',
    Customer: 'customer',
    SalesDestination: 'salesDestination'
} as const;

export type UnmanagedBusinessAutoRegisterSettingTargetFieldType = typeof UnmanagedBusinessAutoRegisterSettingTargetFieldType[keyof typeof UnmanagedBusinessAutoRegisterSettingTargetFieldType];


/**
 * 未管理取引の自動登録条件で比較する対象項目
 * @export
 * @enum {string}
 */

export const UnmanagedBusinessAutoRegisterTargetField = {
    SupplierNumber: 'supplierNumber',
    SupplierName: 'supplierName',
    BusinessNumber: 'businessNumber',
    BusinessName: 'businessName',
    WarehouseNumber: 'warehouseNumber',
    Warehouse: 'warehouse',
    Package: 'package',
    CustomerNumber: 'customerNumber',
    CustomerName: 'customerName',
    SalesDestinationNumber: 'salesDestinationNumber',
    SalesDestinationName: 'salesDestinationName',
    Unit: 'unit',
    EndUser: 'endUser',
    Manufacturer: 'manufacturer',
    OrderPackage: 'orderPackage',
    Moq: 'moq',
    ForecastForReceiptMemo: 'forecastForReceiptMemo',
    PurchaseUnitPrice: 'purchaseUnitPrice',
    SalesUnitPrice: 'salesUnitPrice'
} as const;

export type UnmanagedBusinessAutoRegisterTargetField = typeof UnmanagedBusinessAutoRegisterTargetField[keyof typeof UnmanagedBusinessAutoRegisterTargetField];



/**
 * BusinessFreeColumnsApi - axios parameter creator
 * @export
 */
export const BusinessFreeColumnsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 自由欄設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBusinessFreeColumns: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/setting/business-free-columns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 自由欄設定を変更する
         * @param {ApiBusinessFreeColumnSetting} apiBusinessFreeColumnSetting 変更する自由欄設定
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putBusinessFreeColumns: async (apiBusinessFreeColumnSetting: ApiBusinessFreeColumnSetting, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiBusinessFreeColumnSetting' is not null or undefined
            assertParamExists('putBusinessFreeColumns', 'apiBusinessFreeColumnSetting', apiBusinessFreeColumnSetting)
            const localVarPath = `/setting/business-free-columns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiBusinessFreeColumnSetting, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BusinessFreeColumnsApi - functional programming interface
 * @export
 */
export const BusinessFreeColumnsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BusinessFreeColumnsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 自由欄設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBusinessFreeColumns(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBusinessFreeColumnSettingSuccessResponseResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBusinessFreeColumns(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessFreeColumnsApi.getBusinessFreeColumns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 自由欄設定を変更する
         * @param {ApiBusinessFreeColumnSetting} apiBusinessFreeColumnSetting 変更する自由欄設定
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putBusinessFreeColumns(apiBusinessFreeColumnSetting: ApiBusinessFreeColumnSetting, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putBusinessFreeColumns(apiBusinessFreeColumnSetting, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessFreeColumnsApi.putBusinessFreeColumns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BusinessFreeColumnsApi - factory interface
 * @export
 */
export const BusinessFreeColumnsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BusinessFreeColumnsApiFp(configuration)
    return {
        /**
         * 
         * @summary 自由欄設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBusinessFreeColumns(options?: any): AxiosPromise<GetBusinessFreeColumnSettingSuccessResponseResult> {
            return localVarFp.getBusinessFreeColumns(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 自由欄設定を変更する
         * @param {ApiBusinessFreeColumnSetting} apiBusinessFreeColumnSetting 変更する自由欄設定
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putBusinessFreeColumns(apiBusinessFreeColumnSetting: ApiBusinessFreeColumnSetting, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.putBusinessFreeColumns(apiBusinessFreeColumnSetting, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BusinessFreeColumnsApi - object-oriented interface
 * @export
 * @class BusinessFreeColumnsApi
 * @extends {BaseAPI}
 */
export class BusinessFreeColumnsApi extends BaseAPI {
    /**
     * 
     * @summary 自由欄設定を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessFreeColumnsApi
     */
    public getBusinessFreeColumns(options?: RawAxiosRequestConfig) {
        return BusinessFreeColumnsApiFp(this.configuration).getBusinessFreeColumns(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 自由欄設定を変更する
     * @param {ApiBusinessFreeColumnSetting} apiBusinessFreeColumnSetting 変更する自由欄設定
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessFreeColumnsApi
     */
    public putBusinessFreeColumns(apiBusinessFreeColumnSetting: ApiBusinessFreeColumnSetting, options?: RawAxiosRequestConfig) {
        return BusinessFreeColumnsApiFp(this.configuration).putBusinessFreeColumns(apiBusinessFreeColumnSetting, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DashboardAlertApi - axios parameter creator
 * @export
 */
export const DashboardAlertApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ダッシュボードアラートの設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/setting/dashboard-alert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ダッシュボードアラートの設定を変更する
         * @param {ApiDashboardAlertSetting} apiDashboardAlertSetting 変更する設定情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put: async (apiDashboardAlertSetting: ApiDashboardAlertSetting, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiDashboardAlertSetting' is not null or undefined
            assertParamExists('put', 'apiDashboardAlertSetting', apiDashboardAlertSetting)
            const localVarPath = `/setting/dashboard-alert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiDashboardAlertSetting, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardAlertApi - functional programming interface
 * @export
 */
export const DashboardAlertApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardAlertApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ダッシュボードアラートの設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDashboardAlertSettingSuccessResponseResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAlertApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ダッシュボードアラートの設定を変更する
         * @param {ApiDashboardAlertSetting} apiDashboardAlertSetting 変更する設定情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async put(apiDashboardAlertSetting: ApiDashboardAlertSetting, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.put(apiDashboardAlertSetting, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAlertApi.put']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardAlertApi - factory interface
 * @export
 */
export const DashboardAlertApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardAlertApiFp(configuration)
    return {
        /**
         * 
         * @summary ダッシュボードアラートの設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(options?: any): AxiosPromise<GetDashboardAlertSettingSuccessResponseResult> {
            return localVarFp.get(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ダッシュボードアラートの設定を変更する
         * @param {ApiDashboardAlertSetting} apiDashboardAlertSetting 変更する設定情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put(apiDashboardAlertSetting: ApiDashboardAlertSetting, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.put(apiDashboardAlertSetting, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardAlertApi - object-oriented interface
 * @export
 * @class DashboardAlertApi
 * @extends {BaseAPI}
 */
export class DashboardAlertApi extends BaseAPI {
    /**
     * 
     * @summary ダッシュボードアラートの設定を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAlertApi
     */
    public get(options?: RawAxiosRequestConfig) {
        return DashboardAlertApiFp(this.configuration).get(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ダッシュボードアラートの設定を変更する
     * @param {ApiDashboardAlertSetting} apiDashboardAlertSetting 変更する設定情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAlertApi
     */
    public put(apiDashboardAlertSetting: ApiDashboardAlertSetting, options?: RawAxiosRequestConfig) {
        return DashboardAlertApiFp(this.configuration).put(apiDashboardAlertSetting, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SimulationApi - axios parameter creator
 * @export
 */
export const SimulationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary シミュレーション関連の設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationSetting: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/setting/simulation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シミュレーション関連の設定を変更する
         * @param {ApiSimulationSetting} apiSimulationSetting 変更する設定情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSimulationSetting: async (apiSimulationSetting: ApiSimulationSetting, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiSimulationSetting' is not null or undefined
            assertParamExists('putSimulationSetting', 'apiSimulationSetting', apiSimulationSetting)
            const localVarPath = `/setting/simulation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiSimulationSetting, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SimulationApi - functional programming interface
 * @export
 */
export const SimulationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SimulationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary シミュレーション関連の設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimulationSetting(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSimulationSettingSuccessResponseResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimulationSetting(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulationApi.getSimulationSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シミュレーション関連の設定を変更する
         * @param {ApiSimulationSetting} apiSimulationSetting 変更する設定情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSimulationSetting(apiSimulationSetting: ApiSimulationSetting, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putSimulationSetting(apiSimulationSetting, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulationApi.putSimulationSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SimulationApi - factory interface
 * @export
 */
export const SimulationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SimulationApiFp(configuration)
    return {
        /**
         * 
         * @summary シミュレーション関連の設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationSetting(options?: any): AxiosPromise<GetSimulationSettingSuccessResponseResult> {
            return localVarFp.getSimulationSetting(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シミュレーション関連の設定を変更する
         * @param {ApiSimulationSetting} apiSimulationSetting 変更する設定情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSimulationSetting(apiSimulationSetting: ApiSimulationSetting, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.putSimulationSetting(apiSimulationSetting, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SimulationApi - object-oriented interface
 * @export
 * @class SimulationApi
 * @extends {BaseAPI}
 */
export class SimulationApi extends BaseAPI {
    /**
     * 
     * @summary シミュレーション関連の設定を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimulationApi
     */
    public getSimulationSetting(options?: RawAxiosRequestConfig) {
        return SimulationApiFp(this.configuration).getSimulationSetting(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シミュレーション関連の設定を変更する
     * @param {ApiSimulationSetting} apiSimulationSetting 変更する設定情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimulationApi
     */
    public putSimulationSetting(apiSimulationSetting: ApiSimulationSetting, options?: RawAxiosRequestConfig) {
        return SimulationApiFp(this.configuration).putSimulationSetting(apiSimulationSetting, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UnmanagedBusinessAutoRegisterSettingApi - axios parameter creator
 * @export
 */
export const UnmanagedBusinessAutoRegisterSettingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 未管理取引の自動登録設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnmanagedBusinessAutoRegisterSetting: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/unmanaged-business-auto-register-setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 未管理取引の自動登録設定を保存する
         * @param {PutUnmanagedBusinessAutoRegisterSettingRequest} putUnmanagedBusinessAutoRegisterSettingRequest 未管理取引の自動登録設定更新内容
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUnmanagedBusinessAutoRegisterSetting: async (putUnmanagedBusinessAutoRegisterSettingRequest: PutUnmanagedBusinessAutoRegisterSettingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'putUnmanagedBusinessAutoRegisterSettingRequest' is not null or undefined
            assertParamExists('putUnmanagedBusinessAutoRegisterSetting', 'putUnmanagedBusinessAutoRegisterSettingRequest', putUnmanagedBusinessAutoRegisterSettingRequest)
            const localVarPath = `/unmanaged-business-auto-register-setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putUnmanagedBusinessAutoRegisterSettingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnmanagedBusinessAutoRegisterSettingApi - functional programming interface
 * @export
 */
export const UnmanagedBusinessAutoRegisterSettingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnmanagedBusinessAutoRegisterSettingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 未管理取引の自動登録設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnmanagedBusinessAutoRegisterSetting(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUnmanagedBusinessAutoRegisterSettingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnmanagedBusinessAutoRegisterSetting(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnmanagedBusinessAutoRegisterSettingApi.getUnmanagedBusinessAutoRegisterSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 未管理取引の自動登録設定を保存する
         * @param {PutUnmanagedBusinessAutoRegisterSettingRequest} putUnmanagedBusinessAutoRegisterSettingRequest 未管理取引の自動登録設定更新内容
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putUnmanagedBusinessAutoRegisterSetting(putUnmanagedBusinessAutoRegisterSettingRequest: PutUnmanagedBusinessAutoRegisterSettingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutUnmanagedBusinessAutoRegisterSettingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putUnmanagedBusinessAutoRegisterSetting(putUnmanagedBusinessAutoRegisterSettingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnmanagedBusinessAutoRegisterSettingApi.putUnmanagedBusinessAutoRegisterSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UnmanagedBusinessAutoRegisterSettingApi - factory interface
 * @export
 */
export const UnmanagedBusinessAutoRegisterSettingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnmanagedBusinessAutoRegisterSettingApiFp(configuration)
    return {
        /**
         * 
         * @summary 未管理取引の自動登録設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnmanagedBusinessAutoRegisterSetting(options?: any): AxiosPromise<GetUnmanagedBusinessAutoRegisterSettingResponse> {
            return localVarFp.getUnmanagedBusinessAutoRegisterSetting(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 未管理取引の自動登録設定を保存する
         * @param {PutUnmanagedBusinessAutoRegisterSettingRequest} putUnmanagedBusinessAutoRegisterSettingRequest 未管理取引の自動登録設定更新内容
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUnmanagedBusinessAutoRegisterSetting(putUnmanagedBusinessAutoRegisterSettingRequest: PutUnmanagedBusinessAutoRegisterSettingRequest, options?: any): AxiosPromise<PutUnmanagedBusinessAutoRegisterSettingResponse> {
            return localVarFp.putUnmanagedBusinessAutoRegisterSetting(putUnmanagedBusinessAutoRegisterSettingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UnmanagedBusinessAutoRegisterSettingApi - object-oriented interface
 * @export
 * @class UnmanagedBusinessAutoRegisterSettingApi
 * @extends {BaseAPI}
 */
export class UnmanagedBusinessAutoRegisterSettingApi extends BaseAPI {
    /**
     * 
     * @summary 未管理取引の自動登録設定を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnmanagedBusinessAutoRegisterSettingApi
     */
    public getUnmanagedBusinessAutoRegisterSetting(options?: RawAxiosRequestConfig) {
        return UnmanagedBusinessAutoRegisterSettingApiFp(this.configuration).getUnmanagedBusinessAutoRegisterSetting(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 未管理取引の自動登録設定を保存する
     * @param {PutUnmanagedBusinessAutoRegisterSettingRequest} putUnmanagedBusinessAutoRegisterSettingRequest 未管理取引の自動登録設定更新内容
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnmanagedBusinessAutoRegisterSettingApi
     */
    public putUnmanagedBusinessAutoRegisterSetting(putUnmanagedBusinessAutoRegisterSettingRequest: PutUnmanagedBusinessAutoRegisterSettingRequest, options?: RawAxiosRequestConfig) {
        return UnmanagedBusinessAutoRegisterSettingApiFp(this.configuration).putUnmanagedBusinessAutoRegisterSetting(putUnmanagedBusinessAutoRegisterSettingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



